/**
 * Main Swiper
 */
let mainSwiper = new Swiper('.main-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: false,
    centeredSlides: true,
    loop: true,
    loopedSlides: 1,
    longSwipes: false,
    allowTouchMove: true,
    speed: 1500,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    keyboard: {
        enabled: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});

/**
 * Product Swiper
 */
let productSwiper = new Swiper('.product-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: false,
    loop: true,
    loopedSlides: 1,
    longSwipes: false,
    allowTouchMove: true,
    speed: 1500,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    keyboard: {
        enabled: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    breakpointsInverse: true,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        1140: {
            slidesPerView: 3,
            spaceBetween: 18
        },
        1440: {
            slidesPerView: 3,
            spaceBetween: 20
        }
    },
});
